import React, { useState } from "react";
import styles from "./NotiPopup.module.css";
import backend from "../../../api";

export default function AdminNotify({ open, onClose }) {
  const [target, setTarget] = useState("customers"); // "customers" | "team"
  const [channel, setChannel] = useState("both");    // "email" | "sms" | "both"
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  if (!open) return null;

  const submit = async () => {
    if (!message.trim()) return alert("Message is required.");
    if ((channel === "email" || channel === "both") && !subject.trim()) {
      return alert("Subject is required when sending email.");
    }

    try {
      setLoading(true);
      setDone(false);

      await backend.post("/api/admin/notify", {
        target,   // "customers" or "team"
        channel,  // "email" | "sms" | "both"
        subject,
        message,
      });

      setDone(true);
      setLoading(false);

      setTimeout(() => {
        setDone(false);
        onClose && onClose();
      }, 1500);
    } catch (e) {
      setLoading(false);
      alert(e?.response?.data?.error || e.message);
    }
  };

  return (
    <div className={styles.backdrop}>
      <div className={styles.popup}>
        <h3>Send Notification</h3>

        {/* Target */}
        <div className={styles.field}>
          <label>Send To</label>
          <select value={target} onChange={(e) => setTarget(e.target.value)}>
            <option value="customers">All Customers</option>
            <option value="team">All Team Members</option>
          </select>
        </div>

        {/* Channel */}
        <div className={styles.field}>
          <label>Channel</label>
          <select value={channel} onChange={(e) => setChannel(e.target.value)}>
            <option value="email">Email Only</option>
            <option value="sms">SMS Only</option>
            <option value="both">Email + SMS</option>
          </select>
        </div>

        {/* Subject (only for email) */}
        {(channel === "email" || channel === "both") && (
          <div className={styles.field}>
            <label>Email Subject</label>
            <input
              type="text"
              placeholder="Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>
        )}

        {/* Message */}
        <div className={styles.field}>
          <label>Message</label>
          <textarea
            placeholder="Write your message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        <div className={styles.actions}>
          <button type="button" className={styles.cancelBtn} onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className={styles.sendBtn}
            onClick={submit}
            disabled={loading}
          >
            {loading ? "Sending..." : done ? "Sent ✔" : "Send"}
          </button>
        </div>
      </div>
    </div>
  );
}
